<div *ngIf="cityService.city.PROPERTY_INFLECTED_VALUE != 'России'" class="uk-container">
		<h1 class="Heading--marginLeft uk-margin-remove-bottom">Магазин оборудования и программного обеспечения <span class="Title-City_IN"><br> в {{cityService.city.PROPERTY_INFLECTED_VALUE}}</span></h1>
</div>	

<div *ngIf="cityService.city.PROPERTY_INFLECTED_VALUE == 'России'" class="uk-container">
	<h1 class="Heading--marginLeft uk-margin-remove-bottom">Магазин оборудования и программного обеспечения</h1>
</div>

<div class="uk-container">
	<div class="ShortCodeFilter" [ngClass]="{'ShortCodeFilter--hidden': filterDisplay.isHidden, 'uk-overflow-hidden': filterDisplay.isOverflow}">
		<h2 class="ShortCodeFilter_Title">Выберите фильтр, чтобы подобрать нужные товары и услуги</h2>
		<app-filter></app-filter>
	</div>
</div>
<div class="uk-container">
	<div class="uk-flex uk-flex-between uk-flex-bottom uk-margin-medium-bottom" #catalogTitle>
		<div class="Heading-Title_Item">
		</div>
		<div class="Heading--marginRight uk-h2 uk-margin-remove-bottom">
			<span class="uk-text-primary">{{count}} </span
			><span>предложений </span
			><span class="uk-text-primary Filter_Service-Item">{{filterService.activeTargetAudience ? filterService.activeTargetAudience.name : 'для Каждого'}}</span
			><span class="uk-text-primary">{{filterService.activeActivity ? ' ' + filterService.activeActivity.name : ''}}</span>
		</div>
	</div>
</div>

<div class="uk-container">
	<section>
		<div class="uk-margin-small-top uk-margin-xlarge-bottom uk-grid" uk-grid>
			<div class="uk-width-auto@m">
				<catalog-filter
					[loadingState]="loadingState"
					(orderChange)="changeOrder($event)"
				></catalog-filter>
			</div>

			<div class="uk-width-expand@m">
				<catalog-items [items]="catalog" [isCatalogReady]="isCatalogReady"></catalog-items>

				<div class="CatalogPagination" *ngIf="isPaginationReady">
					<app-pagination
						[loadingState]="loadingState"
						[countPages]="countPages"
						(pageChange)="changePage($event)"
					></app-pagination>
				</div>
			</div>
		</div>
	</section>
</div>

<div class="uk-background-muted">
	<div class="uk-container">
		<promo-slider></promo-slider>
	</div>
</div>
